import React from 'react';

import classnames from 'classnames/bind';
import styles from './ProductDetails.module.scss';
import { Typography, Skeleton } from 'gd-design-library';

const CN = 'product-details';
const galleryClassName = `${CN}__gallery`;
const infoClassName = `${CN}__info`;
const infoStickyClassName = `${CN}__info-sticky`;

const cx = classnames.bind(styles);

export const ProductDetailsSkeleton: React.FC = () => (
  <div className={ cx(CN) }>
    <Skeleton variant='rectangular' height='500px' className={ cx(galleryClassName) }/>
    <div className={ cx(infoClassName) }>
      <div className={ cx(infoStickyClassName) }>
        <Typography variant='h5'><Skeleton/></Typography>
        <Skeleton width='30%'/>
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton width='50%'/>
        <Skeleton width='30%'/>
        <Skeleton height='50px'/>
        <Skeleton height='50px'/>
        <Skeleton width='30%'/>
        <Skeleton height='50px'/>
        <Skeleton height='50px'/>
      </div>
    </div>
  </div>
);
